export default function () {
  if (document.querySelector('.ideal-location')) {
    // eslint-disable-next-line no-unused-expressions
    import(
      /* webpackChunkName: "ideal-location" */ '../_03_organisms/ideal-location-map-filters'
    );
  }
}
